import React from 'react';
import LogoPng from '../../assets/images/login_logo.png';
import GuoruPng from '../../assets/images/guoru.png';
import { crmManageAccount } from '../../utils/utils';

export default function Logo() {
  const { id } = crmManageAccount();

  return (
    <img 
      src={id === 49 ? GuoruPng : LogoPng} 
      alt="Logo" 
      style={{ width: '260px' }} 
    />
  );
}
